import { render, staticRenderFns } from "./SettingsStageType.vue?vue&type=template&id=67e3d587&"
import script from "./SettingsStageType.vue?vue&type=script&lang=js&"
export * from "./SettingsStageType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports